var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDtl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7377 5.59971L16.4836 9.34533C16.7053 9.56708 16.7257 9.914 16.5445 10.1587L16.4841 10.2287L12.7382 13.9828C12.4944 14.2272 12.0987 14.2276 11.8543 13.9837C11.6322 13.7621 11.6117 13.4149 11.7929 13.1701L11.8534 13.0999L14.5341 10.4142L3.95424 10.4147C3.63782 10.4147 3.37632 10.1796 3.3349 9.8745L3.32924 9.78975C3.32924 9.47333 3.56432 9.21183 3.8694 9.17041L3.95424 9.16475L14.5357 9.16416L11.8538 6.48362C11.632 6.26174 11.6117 5.91452 11.7933 5.66984L11.8538 5.59974C12.0757 5.37784 12.4229 5.35766 12.6676 5.5392L12.7377 5.59971L16.4836 9.34533L12.7377 5.59971Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtl);
export default __webpack_public_path__ + "static/media/dtl.905d549287364aa97d23a3c9816f5138.svg";
export { ForwardRef as ReactComponent };